<div
  style="
    padding: 15px;
    min-width: 500px;
    min-height: 400px;
    background-color: #ffffff;
  "
>
  <h2>Submit a charge</h2>

  <mat-dialog-content>
    <div>Last 4: {{ this.paymentMethod.nickname }}</div>

    <div>Total: $<input type="text" name="txtTotalCharge" /></div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div style="width: 100%; text-align: center">
      <input type="button" mat-button mat-dialog-close value="Cancel" />
      &nbsp;&nbsp;&nbsp;&nbsp;
      <input
        type="button"
        mat-button
        [mat-dialog-close]="true"
        value="Submit"
      />
    </div>
  </mat-dialog-actions>
</div>
